import React from "react";
import { useTranslation } from "react-i18next";
import Card from "components/Card";
import Empty from "components/Empty";
import Loader from "components/Loader";
import Page from "components/Page";
import styles from "../../OfficePolicyManagement.module.scss";
import { useLatestPolicyRedirect } from "accountOwner/pages/OfficePolicyManagement/hooks/useLatestPolicyRedirect";

const SHELL_CARD_CLASS = ` ${styles["task_details_card"]} `;

/**
 * Interstitial route for `/office-policy-management/:policyFolderId/policies`.
 * Loads the latest policy, then opens the encoded assignment details URL.
 */
export default function LatestPolicyRedirect() {
  const { t } = useTranslation();
  const { hasError, goToPreviousScreen } = useLatestPolicyRedirect();

  if (hasError) {
    return (
      <Page
        onBack={goToPreviousScreen}
        title={t("officePolicyManagement.policyDetails")}
      >
        <Card className={SHELL_CARD_CLASS}>
          <Empty Message={t("officePolicyManagement.policyNotFound")} />
        </Card>
      </Page>
    );
  }

  return <Loader />;
}
